"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardVictoryPoints = void 0;
const vue_1 = require("vue");
const CardRenderDynamicVictoryPoints_1 = require("../../cards/render/CardRenderDynamicVictoryPoints");
const CardRenderItemComponent_1 = require("./CardRenderItemComponent");
exports.CardVictoryPoints = vue_1.default.component('CardPoints', {
    props: {
        victoryPoints: {
            required: true,
        },
    },
    components: {
        CardRenderItemComponent: CardRenderItemComponent_1.CardRenderItemComponent,
    },
    methods: {
        getClasses: function () {
            const classes = ['card-points'];
            if (this.isObject()) {
                const item = this.victoryPoints;
                if (item.anyPlayer) {
                    classes.push('card-points-big');
                    classes.push('red-outline');
                }
                else {
                    classes.push('card-points-normal');
                }
            }
            else {
                classes.push('card-points-big');
            }
            return classes.join(' ');
        },
        isObject: function () {
            return this.victoryPoints instanceof CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints;
        },
    },
    template: `
      <div v-if="isObject() && !this.victoryPoints.targetOneOrMore && !this.victoryPoints.multirow" :class="getClasses()">
        <div>{{ this.victoryPoints.getPointsHtml() }}</div><CardRenderItemComponent v-if="this.victoryPoints.item !== undefined" :item="this.victoryPoints.item" /></div>
      <div v-else-if="isObject() && this.victoryPoints.targetOneOrMore" :class="getClasses()">
        <div class="card-points-item-first"><CardRenderItemComponent v-if="this.victoryPoints.item !== undefined" :item="this.victoryPoints.item" />*:3</div>
      </div>
      <div v-else-if="isObject() && this.victoryPoints.multirow" :class="getClasses()">
        <div class="card-points-container">
          <div class="card-points-header">10 animals:</div>
          <div class="card-points-item-first card-points-row">
            <div>{{ this.victoryPoints.getPointsHtml() }}</div><CardRenderItemComponent v-if="this.victoryPoints.item !== undefined" :item="this.victoryPoints.item" />*</div>
          </div>
        </div>
      </div>
      <div v-else :class="getClasses()">{{ this.victoryPoints }}</div>
    `,
});
//# sourceMappingURL=CardVictoryPoints.js.map